export const CDN_DATA_BASE =
  "https://cdn.jsdelivr.net/gh/developersmith03-arch/data@develop";

/**
 * Prefix root-relative static paths for img src. Leaves http(s), //, data:, blob: unchanged.
 */
export function cdnImg(path) {
  if (path == null || path === "") return path;
  const s = String(path);
  if (/^https?:\/\//i.test(s) || s.startsWith("//")) return s;
  if (s.startsWith("data:") || s.startsWith("blob:")) return s;
  let p = s.replace(/^(\.\.\/|\.\/)+/, "");
  if (p.startsWith("/")) p = p.slice(1);
  return `${CDN_DATA_BASE}/${p}`;
}
